import { Component } from '@angular/core';

@Component({
  selector: 'limited-edition-icon',
  standalone: true,
  imports: [],
  templateUrl: './limited-edition.component.html',
  styleUrl: './limited-edition.component.scss'
})
export class LimitedEditionIcon {

}
